import { EyeClosedIcon, EyeIcon } from 'lucide-react';
import * as React from 'react';
import { cn } from '../utils';

export interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(({ className, type = 'password', ...props }, ref) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const inputType = type === 'password' && showPassword ? 'text' : type;

  return (
    <div className='relative'>
      <input
        type={inputType}
        className={cn(
          'flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />

      <button type='button' className='absolute right-3 top-1/2 -translate-y-1/2' onClick={togglePasswordVisibility}>
        {showPassword ? <EyeIcon className='h-4 w-4 text-gray-500' /> : <EyeClosedIcon className='h-4 w-4 text-gray-500' />}
      </button>
    </div>
  );
});

PasswordInput.displayName = 'PasswordInput';

export { PasswordInput };
